import { render } from "./EventPrc3.vue?vue&type=template&id=72babb26&scoped=true"
import script from "./EventPrc3.vue?vue&type=script&lang=js"
export * from "./EventPrc3.vue?vue&type=script&lang=js"

import "./EventPrc3.vue?vue&type=style&index=0&id=72babb26&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72babb26"]])

export default __exports__